<script setup>
  import { getJobUrl } from '~/utils/url'

  const { job } = defineProps({
    job: { required: true, type: Object }
  })

  const route = useRoute()
</script>

<template>
  <NuxtLink class="block shadow duration-300 hover:shadow-md" :to="getJobUrl(job)">
    <div
      class="relative w-full bg-zinc-300 bg-cover bg-center pt-[56.25%]"
      :style="{
        backgroundImage:
          job.header?.cover?.url || job.employer?.cover?.url
            ? `url('${useStrapiMedia(job.header?.cover?.url || job.employer?.cover?.url)}')`
            : undefined
      }"
    >
      <div class="absolute right-4 top-2 z-[5]">
        <FavoriteToggle customClass="transition-colors duration-300" :job="job" :route="route.fullPath" size="md" style="color: white" />
      </div>

      <div class="absolute inset-0 flex h-full w-full flex-col items-center justify-center space-y-2 overflow-hidden bg-black/50 p-4 font-bold">
        <div class="line-clamp-2 text-center font-special text-white">{{ job.title }}</div>
        <div
          class="line-clamp-1 text-center text-viking-400"
          v-if="job.header?.title || job.employer?.name"
          v-text="job.header?.title || job.employer?.name"
        />
      </div>
    </div>
    <div class="flex bg-white px-4 py-2">
      <div
        class="h-12 w-12 flex-none rounded-full bg-zinc-300 bg-cover bg-center"
        :style="{
          backgroundImage: `url('${useStrapiMedia(job.moderated && job.speaker?.photo?.url ? job.speaker.photo.url : job.employer?.logo?.url)}')`
        }"
      />
      <div class="ml-4 line-clamp-2 flex-1 self-center">
        <template v-if="job.moderated && job.speaker"
          >{{ job.speaker.firstName }} {{ job.speaker.lastName }} vous dit tout sur le poste&nbsp;!</template
        >
        <template v-else>Ils vous disent tout sur le poste&nbsp;!</template>
      </div>
    </div>
  </NuxtLink>
</template>
